let shortNum = require('short-number');

export default function shortNumberFilterFactory() {
	return function (num) {
		return shortNum(num);
	};
};
